export default __webpack_public_path__ + "static/media/fullscreen-black.f4ee443f.svg";